import React from 'react';
import styled from 'styled-components';

import { Button } from 'components';
import { T } from 'containers';

import { AppText } from 'domain/appText';

const StyledButton = styled(Button)`
  color: #537eaa;
  height: 37px;
  width: calc(100% - 10px);
  background-color: #ecf2f8;
  border: 2px solid #ecf2f8;
  line-height: 0.5em;
  font-weight: bold;
  padding: 5px;
  margin: 5px;
  border-radius: 0px;

  img{
    display: inline-block;
    vertical-align: middle;
    width: 12px;
    height: 12px;
    margin-top: -1px;
    margin-left: 5px;
  }

  span{
    display: inline-block;
    vertical-align: middle;
    line-height: 24px;
  }

  &:hover, &:focus {
      border: 2px solid #dae6f2;
      background-color: white;
      box-shadow: none;
      color: #537eaa;
  }
`;

const DotButton = props => (
  <T
    text={[
      AppText.More,
      AppText.ExpandAllDescription,
    ]}
    render={([
      more,
      expandAllDescription,
    ]) => (
      <StyledButton {...props}>
        <span title={expandAllDescription}>{more}</span>
        <img className="expanded-arrow" src="/assets/images/arrow.svg" alt={expandAllDescription} title={expandAllDescription} />
      </StyledButton>
    )}
  />
);

export default DotButton;



// WEBPACK FOOTER //
// ./src/components/organisms/DotButton/index.js